import {
    Box,
    Flex,
    Input,
    InputGroup,
    InputLeftElement,
    Text,
    VStack,
    Button,
} from "@chakra-ui/react";
import axios from "axios";
import { useEffect, useState } from "react";
import { FiSearch, FiFilter, FiX } from "react-icons/fi";
import Select from "react-select";

export const SearchAndFilter = ({
    onTagFilter,
    tags,
    isLoading,
    searchTerm,
    setSearchTerm,
    currentTagFilter,
    whatsappFilter,
    setWhatsappFilter,
    subscriberFilter,
    setSubscriberFilter,
    cohortFilter,
    setCohortFilter,
}) => {
    const [showFilters, setShowFilters] = useState(false);
    const [cohorts, setCohorts] = useState([]);
    const [isCohortLoading, setIsCohortLoading] = useState(false);

    /* ---------------- OPTIONS ---------------- */

    const whatsappOptions = [
        { value: "all", label: "All" },
        { value: "available", label: "WhatsApp Available" },
        { value: "unavailable", label: "WhatsApp Not Available" },
    ];

    const subscriberOptions = [
        { value: "all", label: "All" },
        { value: "has", label: "Has Subscriber ID" },
        { value: "none", label: "No Subscriber ID" },
    ];

    const tagOptions = [
        { value: "all", label: "All Contacts" },
        ...tags.map((tag) => ({
            value: tag._id || tag.id,
            label: tag.name || tag.label,
        })),
    ];

    const cohortOptions = [
        { value: "all", label: "All Cohorts" },
        ...cohorts,
    ];

    /* ---------------- FETCH COHORTS ---------------- */

    useEffect(() => {
        const fetchCohorts = async () => {
            try {
                setIsCohortLoading(true);
                const url = `${process.env.REACT_APP_API_URL}/cohorts`;

                const res = await axios.get(url, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token":localStorage.getItem("customer-portal"),
                        "x-api-key": localStorage.getItem("api-key"),
                    },
                });

                const data = res?.data?.data?.cohorts || [];

                setCohorts(
                    data.map((c) => ({
                        value: c._id,
                        label: c.name,
                    }))
                );
            } catch (err) {
                console.error("Failed to load cohorts", err);
            } finally {
                setIsCohortLoading(false);
            }
        };

        fetchCohorts();
    }, []);

    /* ---------------- HANDLERS ---------------- */

    const handleClearFilters = () => {
        setSearchTerm("");
        setWhatsappFilter("all");
        setSubscriberFilter("all");
        setCohortFilter("all");
        onTagFilter({ value: "all" });
    };

    const selectedTag =
        tagOptions.find((o) => o.value === currentTagFilter) || tagOptions[0];

    /* ---------------- STYLES ---------------- */

    const customSelectStyles = {
        control: (base) => ({
            ...base,
            minHeight: "0px",
            backgroundColor: "#F7FAFC",
            borderColor: "#CBD5E0",
            width: "220px"
        }),
    };

    /* ---------------- UI ---------------- */

    return (
        <Box bg="white" p={6} borderRadius="lg" border="1px solid #E2E8F0">
            <Text fontSize="lg" fontWeight="semibold" mb={4}>
                Search & Filter
            </Text>

            {/* SEARCH + FILTER TOGGLE */}
            <Flex gap={3} align="center" wrap="wrap">
                <Box flex={1} minW="50%">
                    <InputGroup w={"50%"}>
                        <InputLeftElement pointerEvents="none">
                            <FiSearch color="gray" />
                        </InputLeftElement>
                        <Input
                            placeholder="Search by name, email, or phone..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            isDisabled={isLoading}
                        />
                    </InputGroup>
                </Box>

                <Button
                    leftIcon={<FiFilter />}
                    bg={showFilters ? "var(--brand-primary)" : "transparent"}
                    color={showFilters ? "white" : "black"}
                    variant={showFilters ? "solid" : "outline"}
                    onClick={() => setShowFilters((p) => !p)}
                    size={"sm"}
                >
                    Filters
                </Button>
            </Flex>

            {/* FILTERS ROW */}
            {showFilters && (
                <Box className="box-style-card" mt={4}>
                    <Flex

                        gap={6}
                        align="flex-end"
                        wrap="wrap"
                    >
                        {/* TAG */}
                        <VStack align="flex-start" w="250px" spacing={2}>
                            <Text fontSize="sm" fontWeight="medium">
                                Tag
                            </Text>
                            <Select
                                options={tagOptions}
                                value={selectedTag}
                                onChange={onTagFilter}
                                styles={customSelectStyles}
                            />
                        </VStack>

                        {/* WHATSAPP */}
                        <VStack align="flex-start" w="250px" spacing={2}>
                            <Text fontSize="sm" fontWeight="medium">
                                WhatsApp
                            </Text>
                            <Select
                                options={whatsappOptions}
                                value={whatsappOptions.find(
                                    (o) => o.value === whatsappFilter
                                )}
                                onChange={(opt) => setWhatsappFilter(opt.value)}
                                styles={customSelectStyles}
                            />
                        </VStack>

                        {/* SUBSCRIBER */}
                        <VStack align="flex-start" w="250px" spacing={2}>
                            <Text fontSize="sm" fontWeight="medium">
                                Subscriber
                            </Text>
                            <Select
                                options={subscriberOptions}
                                value={subscriberOptions.find(
                                    (o) => o.value === subscriberFilter
                                )}
                                onChange={(opt) => setSubscriberFilter(opt.value)}
                                styles={customSelectStyles}
                            />
                        </VStack>

                        {/* COHORT */}
                        <VStack align="flex-start" w="250px" spacing={2}>
                            <Text fontSize="sm" fontWeight="medium">
                                Cohort
                            </Text>
                            <Select
                                options={cohortOptions}
                                value={cohortOptions.find((o) => o.value === cohortFilter)}
                                onChange={(opt) => setCohortFilter(opt.value)}
                                isLoading={isCohortLoading}
                                styles={customSelectStyles}
                            />
                        </VStack>

                        {/* CLEAR BUTTON – BESIDE SELECTS */}
                        <Box pb={1}>
                            <Button
                                leftIcon={<FiX />}
                                colorScheme="red"
                                variant="solid"
                                onClick={handleClearFilters}
                                size={"sm"}
                                _hover={{ bg: "#0000001a !important", color: "black !important" }}

                            >
                                Clear Filters
                            </Button>
                        </Box>
                    </Flex>
                </Box>
            )}
        </Box>
    );
};
